module.exports = __webpack_public_path__ + "media/src/img/about-cloud-lh-acd689faf5679fb3d09ad666fc3eec51.png";